import React, { useEffect, useState } from 'react';
import { IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import LoadDetailHeader, { useTransparentHeaderContrast } from '../components/LoadDetailHeader';
import { MessageSvg, PhoneSvg } from '../components/svgIcons';
import { useLogPageVisit } from '../utils/logPageVisit';

const contact = {
  phone: '615-277-7615',
  email: 'traineesupport@westernexp.com',
  name: 'Training Contact Info',
  subcategory: 'Training',
};

const TrainingContacts: React.FC = () => {
  useLogPageVisit('LP Training Contacts', 'User viewed the Training Contacts page');
  const history = useHistory();
  const { onSheet, onIonScroll } = useTransparentHeaderContrast();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      setTimeout(() => setMounted(true), 30);
    });
    return () => cancelAnimationFrame(id);
  }, []);

  const goBack = () => {
    if (history.length > 1) history.goBack();
    else history.replace('/Home');
  };

  return (
    <IonPage>
      <LoadDetailHeader title="Training Contact" onBack={goBack} onSheet={onSheet} />

      <IonContent
        fullscreen
        className="design-a-content design-a-content--light"
        scrollEvents={true}
        onIonScroll={onIonScroll}
      >
        <div className={`design-a design-a--detail${mounted ? ' design-a--mounted' : ''}`}>
          <div className="home-hero advance-hero">
            <div className="advance-hero__eyebrow">Training</div>
            <div className="advance-hero__title home-display">Training Contact</div>
            <div className="advance-hero__meta">Reach the training support team</div>
          </div>

          <div className="home-sheet advance-sheet">
            <div className="home-card">
              <div className="training-meta-card">
                <div className="training-meta-card__row">
                  <span className="training-meta-card__label">Name</span>
                  <span className="training-meta-card__value">{contact.name}</span>
                </div>
                <div className="training-meta-card__divider" />
                <div className="training-meta-card__row">
                  <span className="training-meta-card__label">Department</span>
                  <span className="training-meta-card__value">{contact.subcategory}</span>
                </div>
                <div className="training-meta-card__divider" />
                <div className="training-meta-card__row">
                  <span className="training-meta-card__label">Phone</span>
                  <span className="training-meta-card__value">{contact.phone}</span>
                </div>
                <div className="training-meta-card__divider" />
                <div className="training-meta-card__row">
                  <span className="training-meta-card__label">Email</span>
                  <span className="training-meta-card__value">{contact.email}</span>
                </div>
              </div>
            </div>

            <a href={`tel:${contact.phone}`} className="home-action home-action--tint">
              <span className="home-action__icon">
                <PhoneSvg size={20} />
              </span>
              <span className="home-action__label">Call {contact.phone}</span>
            </a>
            <a href={`mailto:${contact.email}`} className="home-action home-action--tint">
              <span className="home-action__icon">
                <MessageSvg size={20} />
              </span>
              <span className="home-action__label">Email Support</span>
            </a>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default TrainingContacts;
